import React from "react";
import ReactDOM from "react-dom";
import PassBanner from "../components/Passes/PassBanner";
import { initializeI18n } from "../localization/i18n";

window.renderPassBanner = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  initializeI18n()
    .then(() => {
      ReactDOM.render(<PassBanner {...props} />, element);
    })
    .catch(() => {
      ReactDOM.render(<PassBanner {...props} />, element);
    });
};
